import { useEffect, useState } from "react";

export default function SplashScreen({ onFinish }) {
  const [progress, setProgress] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);
  const [logoReady, setLogoReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLogoReady(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => onFinish && onFinish(), 600);
          }, 300);
          return 100;
        }
        return prev + 2;
      });
    }, 40);
    return () => clearInterval(interval);
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 flex flex-col items-center justify-center overflow-hidden z-[9999] transition-opacity duration-600`}
      style={{
        opacity: fadeOut ? 0 : 1,
        background: "linear-gradient(160deg, #0A0F1E 0%, #0D1B36 50%, #0E1628 100%)",
        transition: "opacity 0.6s ease",
      }}
    >
      {/* Ambient radial glows */}
      <div
        className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full pointer-events-none"
        style={{
          width: 600,
          height: 600,
          background: "radial-gradient(ellipse, rgba(79,70,229,0.18) 0%, transparent 70%)",
          filter: "blur(40px)",
        }}
      />
      <div
        className="absolute bottom-1/4 left-1/4 rounded-full pointer-events-none"
        style={{
          width: 300,
          height: 300,
          background: "radial-gradient(ellipse, rgba(232,105,10,0.12) 0%, transparent 70%)",
          filter: "blur(40px)",
        }}
      />

      {/* Center content */}
      <div
        className="flex flex-col items-center gap-6 z-10"
        style={{
          opacity: logoReady ? 1 : 0,
          transform: logoReady ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 0.6s ease, transform 0.6s ease",
        }}
      >
        {/* Logo with glow ring */}
        <div className="relative flex items-center justify-center">
          {/* Glow ring */}
          <div
            className="absolute rounded-[28px]"
            style={{
              width: 148,
              height: 148,
              background: "radial-gradient(ellipse, rgba(79,70,229,0.35) 0%, transparent 70%)",
              filter: "blur(16px)",
            }}
          />
          {/* Logo */}
          <div
            className="relative rounded-[28px] overflow-hidden shadow-2xl"
            style={{
              width: 120,
              height: 120,
              boxShadow: "0 20px 60px rgba(79,70,229,0.4), 0 0 0 1px rgba(255,255,255,0.06)",
            }}
          >
            <img
              src="/logo512.png"
              alt="EduPulseAI"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>

        {/* Brand name */}
        <div className="text-center">
          <div
            className="font-sora font-extrabold tracking-tight mb-1"
            style={{ fontSize: 32, color: "#fff", letterSpacing: "-0.5px" }}
          >
            EduPulse
            <span
              style={{
                background: "linear-gradient(90deg, #E8690A, #F59E0B)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              AI
            </span>
          </div>
          <p
            className="font-sora font-medium tracking-[0.25em] uppercase"
            style={{ fontSize: 10, color: "rgba(255,255,255,0.35)" }}
          >
            Smarter Schools · Brighter Futures
          </p>
        </div>
      </div>

      {/* Progress bar */}
      <div
        className="absolute bottom-16 flex flex-col items-center gap-3 z-10"
        style={{
          width: 180,
          opacity: logoReady ? 1 : 0,
          transition: "opacity 0.8s ease 0.4s",
        }}
      >
        <div
          className="w-full rounded-full overflow-hidden"
          style={{ height: 2, background: "rgba(255,255,255,0.08)" }}
        >
          <div
            className="h-full rounded-full"
            style={{
              width: `${progress}%`,
              background: "linear-gradient(90deg, #4F46E5, #E8690A)",
              transition: "width 75ms linear",
            }}
          />
        </div>
        <p
          className="font-sora font-medium"
          style={{ fontSize: 11, color: "rgba(255,255,255,0.25)", letterSpacing: "0.05em" }}
        >
          {progress < 100 ? "Loading…" : "Ready"}
        </p>
      </div>
    </div>
  );
}
